import type { FlexibleRange } from '@/infrastructure/departure-date/store'
import type { DepartureDateFilterOptions } from '@/scopes/search/components/DepartureDateFilterLegacy/types'
import { useIntl } from '@/intl'

import { Chip, getDaysAround, removePastDatesFromRange, SpaceBetween, tk } from '@sunwebgroup/ui-components'
import { add } from 'date-fns'

import * as React from 'react'
import { styled } from 'styled-components'
import { useDepartureDateFilter } from './hooks'

const StyledControlWrapper = styled.div`
  align-items: center;
  display: flex;
`

export function Chips({ options }: { options: DepartureDateFilterOptions }) {
  const intl = useIntl()
  const { flexibleRange, originDate, setDepartureDate, setFlexibleRange } = useDepartureDateFilter({ options })

  function selectChip(value: FlexibleRange) {
    setFlexibleRange(value)

    if (value === 'exact') {
      return setDepartureDate(originDate)
    }

    const numberOfDays = Number.parseInt(value)
    const date = originDate
    const depDate = date ? getDaysAround(date, numberOfDays) : date
    if (Array.isArray(depDate) && date) {
      const minimDepartureDate = add(new Date(), { days: 1 })
      setDepartureDate(removePastDatesFromRange(depDate, minimDepartureDate))
    }
    else {
      setDepartureDate(depDate)
    }
  }

  return (
    <StyledControlWrapper>
      <SpaceBetween direction="x" spacing={tk('spacing_xs')}>
        <Chip active={flexibleRange === 'exact'} onClick={() => selectChip('exact')}>
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_exact_date' })}
        </Chip>
        <Chip active={flexibleRange === '1 day'} onClick={() => selectChip('1 day')}>
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 1 })}
        </Chip>
        <Chip active={flexibleRange === '3 days'} onClick={() => selectChip('3 days')}>
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 3 })}
        </Chip>
        <Chip active={flexibleRange === '7 days'} onClick={() => selectChip('7 days')}>
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 7 })}
        </Chip>
      </SpaceBetween>
    </StyledControlWrapper>
  )
}
